import { convertToKebabCase } from "../../shared/utils"
import {
  Category,
  CategoryText,
  CategoryTitle,
  Container,
  TopicsLink,
} from "./styled"

import useSWR from "swr"
import {
  fetchSectionCount,
  getSectionsForCategory,
} from "../../../../hooks/useZendeskApi"
import { categoryPageInfo } from "../constants"

export const FaqCategoryLinks = () => {
  const { data: sections } = useSWR("sections", getSectionsForCategory)
  const sectionIds = sections?.map(section => section.id)
  const { data: faqsCountBySection } = useSWR(
    { search: "count", sectionIds },
    fetchSectionCount
  )

  return (
    <Container>
      {sections?.map(section => (
        <Category key={section.id}>
          <CategoryText>
            <CategoryTitle>{section.name}</CategoryTitle>
            <TopicsLink href={`/faqs/${convertToKebabCase(section.name)}`}>
              {`${
                (faqsCountBySection && faqsCountBySection[section.id]) || 0
              } Topics`}
            </TopicsLink>
          </CategoryText>
          <img
            src={
              (
                categoryPageInfo[
                  section.name as keyof typeof categoryPageInfo
                ] as { topicImage: string; pageImage: string; subTitle: string }
              )?.topicImage
            }
            alt={section.name}
          />
        </Category>
      ))}
    </Container>
  )
}
